import type { ItemState } from './@types/ItemState'
import type { SliceItems } from './@types/SliceItems'
import { DEFAULT_DATA_ITEM } from './constants'

const mutateItem = <T extends { id: string }>(id: T['id'], item?: Partial<ItemState<T>>) => {
  return (currentState: SliceItems<T, ItemState<T>>) => ({
    items: {
      ...currentState.items,
      [id]: {
        ...DEFAULT_DATA_ITEM,
        ...currentState?.items?.[id],
        ...item,
      },
    },
  })
}

export default mutateItem
